import createAction from "./utils/createMetaAction";
import createMergedDefaultStateReducer from "./utils/createMergedDefaultStateReducer";
export const openToolbarItemUpdate = createAction("openToolbarItemUpdate");
export default createMergedDefaultStateReducer(
  {
    [openToolbarItemUpdate]: (state, payload) => {
      return {
        ...state,
        openItem: payload
      };
    }
  },
  {
    openItem: ""
  }
);
